'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Dictionary = require('./classes/Dictionary');

var _Dictionary2 = _interopRequireDefault(_Dictionary);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = new _Dictionary2.default({
  CONSERVATIVE: 'Conservative. I want to preserve my initial principal in this investment, with minimal risk.',
  MODERATE: 'Moderate. I am willing to accept some risk to my initial principal and understand I could lose a portion of the money invested.',
  AGGRESSIVE: 'Aggressive. I am willing to accept high risk to aggressively seek returns, and understand I could lose most, or all, of the money invested.'
});